
import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function HomeTab() {
  const [activeTab, setActiveTab] = useState("SWIM");

  const tabs = [
    {
      id: "SWIM",
      title: "SWIM - WMS",
      description:
        "SWIM is a cutting-edge software solution that makes logistics easy and hassle-free. It streamlines operations across warehouses and provides a single-view analysis of inventory, equipment, orders, and documents across marketplaces.",
      impacts: [
        { value: "44%", text: "Reduction in order processing time through automation" },
        { value: "25%", text: "Improvement in inventory accuracy with real-time tracking" },
      ],
      img: "/assets/images/home-crowl-image1.webp",
      article:
        " Optimize your warehouse operations with real-time visibility and intelligent inventory control.",
      link: "/blog-real-time-visibility-intelligent-inventory-control",
    },
    {
      id: "Crawl",
      title: "Last-Mile Delivery Platform",
      description:
        "CRAWL is AWL India’s intelligent last-mile delivery management system designed to simplify distribution. It optimizes routes, reduces delivery time, and ensures complete visibility from warehouse to customer doorstep.",
      impacts: [
        { value: "35%", text: "Faster delivery turnaround time" },
        { value: "20%", text: "Reduction in last-mile costs" },
      ],
      img: "/assets/images/home-crowl-image2.webp",
      article:
        " Boost efficiency and accuracy with robotics designed to handle complex logistics tasks seamlessly.",
      link: "/blog-robotics-for-complex-logistics-automation",
    },
    {
      id: "FINS",
      title: "Financial Insights for Logistics",
      description:
        "FINS provides real-time financial tracking and analytics for logistics operations. From billing automation to freight cost analysis, it empowers businesses to monitor expenses, boost efficiency, and improve profitability.",
      impacts: [
        { value: "30%", text: "Reduction in billing errors" },
        { value: "40%", text: "Faster reconciliation of accounts" },
      ],
      img: "/assets/images/home-crowl-image3.webp",
      article:
        "Accelerate your supply chain with agile, connected, and scalable transport networks.",
      link: "/blog-agile-connected-scalable-transport-networks",
    },
    {
      id: "AQUARIUM",
      title: "Data & Analytics Hub",
      description:
        "AQUARIUM is a central intelligence system that gathers, stores, and analyzes supply chain data. It delivers actionable insights, demand forecasting, and predictive analytics to help businesses make smarter decisions.",
      impacts: [
        { value: "50%", text: "Improvement in demand forecast accuracy" },
        { value: "33%", text: "Boost in decision-making speed with real-time analytics" },
      ],
      img: "/assets/images/home-crowl-image4.webp",
      article:
        "Ensure flawless logistics with data-driven monitoring, compliance, and resource optimization.",
      link: "/blog-data-driven-logistics-monitoring-compliance-optimization",
    },
    {
      id: "CHAKSHU",
      title: "Smart Tracking System",
      description:
        "CHAKSHU is an advanced IoT-based tracking solution that ensures end-to-end shipment visibility. It monitors location, temperature, and condition of goods in real time, reducing risks and increasing customer trust.",
      impacts: [
        { value: "90%", text: "Visibility across entire supply chain" },
        { value: "25%", text: "Reduction in shipment-related complaints" },
      ],
      img: "/assets/images/home-crowl-image5.webp",
      article:
        " Gain end-to-end shipment visibility through AI-driven tracking and smart monitoring.",
      link: "/blog-ai-driven-end-to-end-shipment-visibility",
    },
    {
      id: "VACLOGIX",
      title: "Cold Chain Management",
      description:
        "VACLOGIX is AWL India’s specialized solution for pharmaceuticals, healthcare, and temperature-sensitive goods. It guarantees safe storage and transportation with precise monitoring of temperature and humidity levels.",
      impacts: [
        { value: "99%", text: "Compliance with pharma cold chain standards" },
        { value: "32%", text: "Decrease in product spoilage rates" },
      ],
      img: "/assets/images/home-crowl-image6.webp",
      article:
        "Unlock supply chain intelligence with predictive analytics and decision-making insights.",
      link: "/blog-the-emergence-and-significance-of-vaclogix",
    },
  ];

  return (
    <>

      <section className="tabber-section space">
        <div className="container">
          {/* Heading */}
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-8">
              <div className="heading-text">
                <h2 className="heading center-heading">
                  The smart solutions you deserve
                </h2>
              </div>
            </div>
          </div>

          <div className="tabber-inner">
            {/* Tabs */}
            <ul className="nav nav-tabs" role="tablist">
              {tabs.map((tab) => (
                <li className="nav-item" key={tab.id}>
                  <button
                    className={`nav-link ${activeTab === tab.id ? "active" : ""}`}
                    onClick={() => setActiveTab(tab.id)}
                    role="tab"
                  >
                    {tab.id}
                  </button>
                </li>
              ))}
            </ul>

            {/* Tab Content */}
            <div className="tab-content">
              {tabs.map((tab) => (
                <div key={tab.id} className={`tab-pane ${activeTab === tab.id ? "active" : ""}`} role="tabpanel"  >
                  <div className="tabber-text">
                    <div className="row align-items-center">
                      {/* Left Content */}
                      <div className="col-md-6">
                        <div className="content">
                          <div className="heading">{tab.title}</div>
                          <p>{tab.description}</p>
                        </div>

                        <div className="impact-section">
                          <div className="subtitle">Impactful results</div>
                          <div className="impact-row">
                            {tab.impacts.map((impact, i) => (
                              <div className="impact-col" key={i}>
                                <div className="heading">{impact.value}</div>
                                <p>{impact.text}</p>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>

                      {/* Right Content */}
                      <div className="col-md-6">
                        <div className="img-wrap">
                          <div className="image">
                            <img className="img-responsive" src={tab.img} loading="lazy" alt={tab.title} />
                          </div>
                          <div className="text">
                            <div className="article">Article</div>
                            <div className="heading">{tab.article}</div>
                            <Link to={tab.link} className="learn-more">
                              Learn More <i className="fa-solid fa-chevron-right"></i>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  )
}


